<template>
  <div v-if="props.file">
    <a-image v-if="fileType === 'img'" :width="50" :src="props.file" />
    <video v-else-if="fileType === 'video'" :width="50" :src="props.file" />

    <a-button
      type="primary"
      size="small"
      v-else-if="fileType === 'download'"
      @click="handleDownloadFile(props.file)"
      >下载</a-button
    >
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { download } from "@/views/rdmanagement/serve/index";

export default defineComponent({
  props: {
    file: String,
  },
  setup(props) {
    const fileType = ref(null);

    const typeCondition = {
      img: "png,jpg",
      video: "mp4",
    };

    const setFileType = () => {
      if (!props.file) return;

      const sliceIndex = props.file.lastIndexOf(".") + 1;

      const unknownType = props.file.slice(sliceIndex);

      Object.keys(typeCondition).forEach((key) => {
        const current = typeCondition[key];
        if (current.indexOf(unknownType) !== -1) {
          fileType.value = key;
        }
      });

      if (fileType.value === null) {
        fileType.value = "download";
      }
    };

    const handleDownloadFile = (url) => {
      download(url, "下载");
    };

    setFileType();

    return {
      fileType,
      props,
      handleDownloadFile,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
